
import { CompanyService } from "@/services";
import { DashboardQuickAddButton, DashboardQuickAddButtonType } from "@/utils/dashboard/dashboard-quick-add-button";
import Vue from "vue";
export default Vue.extend({
	props: {
		button: {
			type: Object as ()=>DashboardQuickAddButton,
			required: true
		},
		editMode: Boolean
	},
	methods: {
		deleteButton(){
			this.$emit("delete");
		},
		async onClick(){
			if (this.editMode) return;
			if (this.button.Type == DashboardQuickAddButtonType.PANIC){
				await CompanyService.panic();
			}
			this.$router.push(this.button.getUrl());
		}
	},
	i18nEx: {
		componentPrefix: "components.dashboard"
	},
});
